<template>
  <!-- 产品附件 -->
  <div class="productAccessory">
    <a-row :gutter="24" type="flex" align="top" class="select-container">
      <a-col>
        <span>附件名称 </span>
        <a-input
          style="width: 400px"
          placeholder="请输入附件名称"
          v-model="keywords"
        >
        </a-input>
      </a-col>
      <a-col>
        <a-button type="primary" @click="onSearch"> 搜索 </a-button>
        <a-button type="primary" @click="searchReset" style="margin-left: 8px"
          >重置</a-button
        >
      </a-col>
    </a-row>
    <div class="searchContent">
      <div>
        <a-button type="primary" @click="handleAdd"
          ><a-icon type="plus" />新增</a-button
        >
      </div>
    </div>
    <a-table
      :columns="columns"
      :dataSource="dataSource"
      :pagination="pagination"
      :rowKey="record => record.id"
      :loading="loading"
      :scroll="{ x: 1500 }"
      @change="handleTableChange"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a @click="deletetEnclosure(record)">删除</a>
      </span>
    </a-table>
    <a-drawer
      :title="title"
      placement="right"
      :closable="false"
      :visible="visible"
      width="700"
      @close="handleCancel"
    >
      <div class="drawerContent">
        <a-form
          class="searchForm"
          :form="form"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-form-item label="发布时间">
            <a-date-picker
              show-time
              v-decorator="['publishDate', { rules: rules.publishDate }]"
              style="width: 200px"
            />
          </a-form-item>
          <!-- <a-form-item label="文件属性类型">
            <a-select
              style="width:200px;"
              v-decorator="['enclosureType', { rules: rules.enclosureType }]"
              placeholder="请选择"
            >
              <a-select-option :value="1">pdf </a-select-option>
              <a-select-option :value="2">txt </a-select-option>
              <a-select-option :value="3">log </a-select-option>
              <a-select-option :value="4"
                >.application/octet-stream
              </a-select-option>
              <a-select-option :value="5">.application/pdf </a-select-option>
              <a-select-option :value="6">.doc </a-select-option>
            </a-select>
          </a-form-item> -->
          <a-form-item label="附件类型">
            <j-dict-select-tag
              type="list"
              style="width: 200px"
              :trigger-change="true"
              dictCode="fund_file"
              placeholder="请选择"
              v-decorator="[
                'enclosurePopType',
                { rules: rules.enclosurePopType }
              ]"
            />
          </a-form-item>
          <a-form-item label="选择文件">
            <a-upload
              name="file"
              accept=".zip, .doc, .docx, .pdf"
              :multiple="false"
              :headers="headers"
              :action="uploadAction"
              @change="handleFileChange"
              :file-list="fileUrlList"
              v-decorator="['enclosureFile', { rules: rules.enclosureFile }]"
            >
              <a-button><a-icon type="link" />选择文件</a-button>
            </a-upload>
          </a-form-item>
        </a-form>

        <div class="drawer-bootom-button" v-show="!cancleSubmit">
          <a-popconfirm
            title="确定放弃编辑？"
            @confirm="handleCancel"
            okText="确定"
            cancelText="取消"
          >
            <a-button style="margin-right: 0.8rem">取消</a-button>
          </a-popconfirm>
          <a-button type="primary" @click="handleOK">提交</a-button>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import Vue from 'vue';
import Upload from '@/components/common/Upload';
import { getAction, postAction, postTag } from '@/api/manage';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import moment from 'moment';
import { fileListByCode, fileSave } from '@/api/product';
// 费率结构
export default {
  data() {
    return {
      columns: [
        {
          title: '产品代码',
          dataIndex: 'fundCode',
          align: 'center',
          width: 100
        },
        {
          title: '附件名称',
          dataIndex: 'attachmentName',
          align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          title: '附件类型',
          dataIndex: 'moduleName_dictText',
          align: 'center',
          width: 150
        },
        {
          title: '附件路径',
          dataIndex: 'attachmentPath',
          align: 'center',
          width: 200,
          ellipsis: true,
          customRender: function(text, record, index) {
            if (!text) {
              return '--';
            } else {
              return text;
            }
          }
        },

        {
          title: '发布时间',
          dataIndex: 'publishTime',
          align: 'center',
          ellipsis: true,
          width: 200,
          customRender: function(text, record, index) {
            if (!text) {
              return '--';
            } else {
              return text;
            }
          }
        },
        {
          title: '是否删除',
          dataIndex: 'isDelete',
          align: 'center',
          width: 100,
          customRender: function(text, record, index) {
            if (text == 0) {
              return '否';
            } else {
              return '是';
            }
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: 200,
          fixed: 'right'
        }
      ],
      visible: false,
      title: '新增附件',
      url: {
        enclosureList:
          process.env.VUE_APP_CMS_PRODUCT + '/product/protocol/list',
        addEnclosure: process.env.VUE_APP_CMS_PRODUCT + '/protocol/add', //附件添加
        delEnclosure:
          process.env.VUE_APP_CMS_PRODUCT + '/product/protocol/delete'
      },
      dataSource: [],
      selectedRowKeys: [], //选中的附件
      selectedRows: [], //选中的附件
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      rules: {
        publishDate: [{ required: true, message: '请选择发布时间' }],
        enclosureType: [{ required: true, message: '请选择附件类型' }],
        enclosurePopType: [{ required: true, message: '请选择文件属性类型' }],
        enclosureFile: [{ required: true, message: '请选择文件上传' }]
      },
      headers: { 'X-Access-Token': Vue.ls.get(ACCESS_TOKEN) },
      uploadAction:
        process.env.VUE_APP_GATEWAY_URL + 'system-file-biz/resources/upload',
      form: this.$form.createForm(this), //form对象
      fileUrlList: [
        // {
        //   uid: '1',
        //   name: 'xxx.png',
        //   url: 'http://www.baidu.com/xxx.png',
        // },
      ], //上传列表
      pagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      keywords: '',
      cancleSubmit: false,
      enclosureId: '', //附件id
      loading: false,
      fileList: [],
      attachmentList: []
    };
  },

  created() {
    this.getList();
  },
  components: {
    JDictSelectTag,
    Upload
  },
  methods: {
    searchReset() {
      this.keywords = '';
      this.onSearch();
    },
    getList() {
      let fundCode = this.$route.query.fundCode;
      let that = this;
      that.loading = true;

      fileListByCode({
        fundCode: fundCode,
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.current
      }).then(res => {
        if (res.success) {
          that.loading = false;
          this.dataSource = res.result.records;
          this.pagination.total = res.result.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.pagination = pagination;
      this.dataSource = [];
      this.getList();
    },
    handleCancel() {
      this.visible = false;
      this.fileUrlList = [];
      this.form.resetFields();
    },
    //根据名称搜索附件
    onSearch() {
      let fundCode = this.$route.query.fundCode;
      let that = this;
      that.loading = true;
      fileListByCode({
        fundCode: fundCode,
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.current,
        attachmentName: this.keywords
      }).then(res => {
        if (res.success) {
          that.loading = false;
          this.dataSource = res.result.records;
          this.pagination.total = res.result.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //编辑附件
    handleEdit(record) {
      this.form.resetFields();
      this.$nextTick(() => {});
      this.visible = true;
      this.title = '编辑附件';
      this.enclosureId = record.id;
      // 处理文件列表
      this.fileList = [
        {
          uid: record.id,
          name: record.attachmentName,
          url: record.attachmentPath
        }
      ];
      this.fileUrlList = this.fileList;
      console.log(this.fileUrlList);
      //给form表单赋值
      this.$nextTick(() => {
        this.form.setFieldsValue({
          publishDate: moment(record.publishTime),
          enclosureType: record.type,
          enclosurePopType: record.moduleName,
          enclosureFile: this.fileUrlList
        });
      });
    },
    handleAdd() {
      this.form.resetFields();
      this.attachmentList = [];
      this.fileList = [];
      console.log(this.fileList, '>>>');

      this.visible = true;
      this.form.resetFields();
    },
    //table选择
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    //文件上传
    handleFileChange(info) {
      const { file, fileList } = info;
      let status = file.status;

      if (status == 'done') {
        this.$message.success('上传成功！');
        let index = this.fileUrlList.findIndex(item => item.name == file.name);
        let res = file.response;
        this.attachmentList = [];
        let fileObj = {
          uid: file.uid,
          name: file.name,
          createdTime: file.lastModifiedDate,
          size: file.size,
          fileName: res.result.fileName,
          url: res.result.fileUrl //res.result,
        };
        this.attachmentList.push(fileObj);
        index != -1 && this.fileUrlList.splice(index, 1);
        this.fileUrlList = this.attachmentList; //this.fileUrlList.concat(attachmentList);
      } else {
        this.fileUrlList = [...fileList];
      }
    },

    //提交表单
    handleOK() {
      if (this.fileUrlList.length == 0) {
        this.$message.warning('您还未上传相关文件，请先上传');
        return;
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          let params = {
            attachmentName: this.fileUrlList[0].name, //文件名称
            attachmentPath: this.fileUrlList[0].fileName, //文件路径
            fundCode: this.$route.query.fundCode, //基金代码
            // type: values.enclosureType, //文件类型
            publishTime: moment(values.publishDate).format(
              'YYYY-MM-DD HH:mm:ss'
            ), //发布时间
            moduleName: values.enclosurePopType, //文件属性类型
            id: this.enclosureId //某条记录的id
          };
          fileSave(params).then(res => {
            if (res.success) {
              this.visible = false;
              this.form.resetFields();

              this.fileUrlList = [];
              this.getList();
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    deletetEnclosure(record) {
      let that = this;
      that.$confirm({
        title: '确认删除',
        content: '确定要删除吗',
        onOk: function() {
          let formData = new FormData();
          formData.append('id', record.id);
          postTag(that.url.delEnclosure, formData).then(res => {
            if (res.success) {
              that.getList();
            } else {
              that.$message.error(res.message);
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.productAccessory {
  padding: 25px;
}
.searchContent {
  width: 100%;
  display: flex;
  margin-bottom: 15px;
  justify-content: space-between;
  margin: 20px 0;
}

.drawerContent {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .searchForm {
    flex: 1;
    margin-top: 20px;
  }
  .drawer-bootom-button {
    width: 100%;
    // height: 80px;
    border-top: 1px solid #e8e8e8;
    text-align: right;
    padding: 10px 16px;
    border-radius: 0 0 2px 2px;
  }
}

/deep/ .ant-drawer-wrapper-body {
  display: flex;
  flex-direction: column;
}
/deep/ .ant-drawer-body {
  flex: 1;
  padding: 0;
}
</style>
